import { render } from "./bookmark_folder_edit.vue?vue&type=template&id=49594f70"
import script from "./bookmark_folder_edit.js?vue&type=script&lang=js"
export * from "./bookmark_folder_edit.js?vue&type=script&lang=js"

import "./bookmark_folder_edit.vue?vue&type=style&index=0&id=49594f70&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__